import React from 'react'
import {ImagePicker} from '../../components/Letflow/Form';
import localization from '../../config/localization';
import {TextValidator} from "react-material-ui-form-validator";
import {
  Checkbox, Dialog, DialogContent,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup, TextField,
  Tooltip
} from "@material-ui/core";
import TranslatableInputs from "../../components/Letflow/TranslatableInputs";
import FormTagSelection from "../../components/Letflow/Form/FormTagSelection";
import Button from "@material-ui/core/Button";
import browserHistory from "../../utils/browserHistory";
import { Add, ArrowDropDown, ArrowDropUp, Close, CloudDownload, Done } from "@material-ui/icons";
import ClientSidePaginationTable from "../../components/Letflow/Table/ClientSidePaginationTable";
import {TableButtonsBuilder} from "../../components/Letflow/Table";
import {request} from "../../api-client";
import arrayMove from "array-move";
import AsyncSelect from "react-select/lib/Async";
import SocialLinks from "../../components/Letflow/SocialLinks";
import FilePondUploader from "../../components/Letflow/FilePondUploader";
import Unsplash from "../../components/Letflow/Unsplash";
import DateFnsUtils from "@date-io/date-fns";
import {DatePicker, MuiPickersUtilsProvider} from "material-ui-pickers";
import {stateToHTML} from "draft-js-export-html";
import {makeImageUrlWithSize} from "../../layouts/Home/HomeElements/utils";
import EditorialEditor from "../../components/Letflow/RichTextEditor/EditorialEditor";
import TableButton from "../../components/Letflow/Table/Buttons/TableButton";

const FormContent = ({
  id,
  nameEs,
  nameEn,
  namePt,
  email,
  phone,
  descriptionEs,
  descriptionEn,
  descriptionPt,
  image,
  onChange,
  onImageChange,
  disabled,
  tagGroups,
  onSelectedTagsChanged,
  country,
  residence,
  onAsyncCountriesChange,
  onResidenceChange,
  onActiveChange,
  active,
  contentCreations,
  onContentCreationsOrderChanged,
  handleContentCreationRemoved,
  selectedCatalogs,
  onSelectedContentCreatorTypeChange,
  selectedContentCreatorType,
  socialLinks,
  onSocialLinksChange,
  availableContentCreatorTypes,
  coverImage,
  onCoverImageChange,
  disableForm,
  updateDisableForm,
  onSetPreview,
  weight,
  onSetCoverImageFromUnsplash,
  onSetProfileImageFromUnsplash,
  coverImageRadio,
  profileImageRadio,
  onImageRadiosChange,
  startActivity,
  handleStartActivityChange,
  countryIsCompleted,
  isTalent,
  isAudiovisual,
  onContentChange,
  onDownloadableMaterialChange,
  setDownloadableMaterialFileType,
  downloadableMaterialText,
  downloadableMaterialFilename,
  onDownloadableMaterialDelete,
  onContentSupervisorChange,
  contentSupervisor,
  onlyArgentina,
  releaseDate,
  expireDate,
  hasExpiredDate,
  onHasExpiredDateChange,
  isPermanentContent,
  onIsPermanentContentChange,
  downloadableMaterialRadio,
  requireLogin,
  onRequireLoginChange,
  downloadableMaterialLink,
  showHelper,
  updateHelper,
  hasSuggestedCarousel,
  onSuggestedCarouselChange,
  suggestedCarouselRadio,
  onSuggestedCarouselPlaylistChange,
  suggestedCarouselPlaylist,
  authorEn,
  authorEs,
  authorPt,
  categoryEn,
  categoryEs,
  categoryPt,
  metadata,
  synopsisEn,
  synopsisEs,
  synopsisPt,
  profileUrl,
}) => {
  return (
    <div>
      <br/>
      <Dialog open={showHelper} onBackdropClick={updateHelper} onEscapeKeyDown={updateHelper}>
        <DialogContent>
          <p>{localization.get('content_creator.helper')}</p>
        </DialogContent>
      </Dialog>
      {!id ?
        <>
          <FormControl fullWidth>
            <span>{localization.get('form.select_content_creator_type')}</span>
            <AsyncSelect
              styles={{
                menu: base => ({
                  ...base,
                  zIndex: 10
                })
              }}
              theme={theme => ({
                ...theme,
                borderRadius: 0
              })}
              placeholder={localization.get('content_creator_types')}
              loadingMessage={() => localization.get('loading')}
              noOptionsMessage={() => localization.get('no_options')}
              onChange={onSelectedContentCreatorTypeChange}
              value={selectedContentCreatorType}
              loadOptions={input => request.contentCreatorType.getAll(
                {
                  orderBy: {column: "name", type: "ASC"},
                  filterBy: [
                    {column: "name", filter: input},
                    {column: "type", filter: isTalent ? 'talent' : isAudiovisual ? 'audiovisual' : 'editorial'},
                  ]
                })
                .then(contentCreatorTypes => contentCreatorTypes.map(type => ({
                  value: type.id,
                  label: type.name,
                  slug: type.slug,
                  type: type.type,
                  client: type.client_id
                })))}
              defaultOptions
            />
          </FormControl>
          <br/>
          <br/>
        </>
        :
        <>
          <FormControl fullWidth>
            <span>{localization.get('form.select_content_creator_type')}</span>
            <AsyncSelect
              styles={{
                menu: base => ({
                  ...base,
                  zIndex: 10
                })
              }}
              theme={theme => ({
                ...theme,
                borderRadius: 0
              })}
              placeholder={localization.get('content_creator_types')}
              loadingMessage={() => localization.get('loading')}
              noOptionsMessage={() => localization.get('no_options')}
              onChange={onSelectedContentCreatorTypeChange}
              value={selectedContentCreatorType}
              loadOptions={(inputValue, callback) => {
                callback(availableContentCreatorTypes.filter(i =>
                  i.label.toLowerCase().includes(inputValue.toLowerCase())
                ))
              }}
              defaultOptions={availableContentCreatorTypes}
            />
          </FormControl>
          <br/>
        </>
      }

      <TranslatableInputs
        children={[
          {
            language: 'es',
            content: [
              <TextValidator
                style={{width: "100%", marginBotton: 15}}
                id="nameEs"
                label={localization.get(!isTalent && !isAudiovisual ? 'form.title' : 'form.name')}
                name="nameEs"
                value={nameEs}
                onChange={onChange}
                disabled={disabled}
                validators={['required']}
                errorMessages={[localization.get('validator.is_required')]}
              />,
              <>
                {!isAudiovisual && !isTalent &&
                <>
                  <TextValidator
                    style={{width: "100%", marginBotton: 15}}
                    id="categoryEs"
                    label={localization.get('form.section')}
                    name="categoryEs"
                    value={categoryEs}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <TextValidator
                    style={{width: "100%", marginBotton: 15}}
                    id="authorEs"
                    label={localization.get('form.author')}
                    name="authorEs"
                    value={authorEs}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <TextValidator
                    style={{width: "100%", marginBotton: 15}}
                    id="synopsisEs"
                    label={localization.get('form.synopsis')}
                    helperText={localization.get("form.synopsis_helper")}
                    name="synopsisEs"
                    value={synopsisEs}
                    onChange={onChange}
                    disabled={disabled}
                  />
                </>
                }
              </>,
              ((selectedContentCreatorType.type === 'audiovisual' || selectedContentCreatorType.type === 'talent') &&
                <>
                  <TextValidator
                    style={{display: "none"}}
                    id="descriptionEs"
                    label={localization.get('form.description')}
                    name="descriptionEs"
                    value={stateToHTML(descriptionEs.getCurrentContent())}
                    onChange={onChange}
                    disabled={disabled}
                    isHtml={true}
                  />
                  <div id="ignore">
                    <div style={{marginBottom: "-2rem"}}>{localization.get('form.description')}</div>
                    <EditorialEditor
                      toolbarOptions={['inline', 'blockType', 'list', 'link', 'remove', 'history']}
                      editorState={descriptionEs}
                      onChange={(e) => onContentChange(e, 'descriptionEs')}
                    />
                  </div>
                </>
              )
            ]
          },
          {
            language: 'en',
            content: [
              <TextValidator
                style={{width: "100%", marginBottom: 15}}
                id="nameEn"
                label={localization.get(selectedContentCreatorType.type ? 'form.title' : 'form.name')}
                name="nameEn"
                value={nameEn}
                onChange={onChange}
                disabled={disabled}
                validators={['required']}
                errorMessages={[localization.get('validator.is_required')]}
              />,

              <>
                {!isAudiovisual && !isTalent &&
                <>
                  <TextValidator
                    style={{width: "100%", marginBotton: 15}}
                    id="categoryEn"
                    label={localization.get('form.section')}
                    name="categoryEn"
                    value={categoryEn}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <TextValidator
                    style={{width: "100%", marginBotton: 15}}
                    id="authorEn"
                    label={localization.get('form.author')}
                    name="authorEn"
                    value={authorEn}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <TextValidator
                    style={{width: "100%", marginBotton: 15}}
                    id="synopsisEn"
                    label={localization.get('form.synopsis')}
                    helperText={localization.get("form.synopsis_helper")}
                    name="synopsisEn"
                    value={synopsisEn}
                    onChange={onChange}
                    disabled={disabled}
                  />,
                </>
                }
              </>,
              ((selectedContentCreatorType.type === 'audiovisual' || selectedContentCreatorType.type === 'talent') &&
                <>
                  <TextValidator
                    style={{display: "none"}}
                    id="descriptionEn"
                    label={localization.get('form.title')}
                    name="descriptionEn"
                    value={descriptionEn}
                    onChange={onChange}
                    disabled={disabled}
                    multiline
                    isEditorState={true}
                  />
                  <div id="ignore">
                    <div style={{marginBottom: "-2rem"}}>{localization.get('form.description')}</div>
                    <EditorialEditor
                      toolbarOptions={['inline', 'blockType', 'list', 'link', 'remove', 'history']}
                      editorState={descriptionEn}
                      onChange={(e) => onContentChange(e, 'descriptionEn')}
                    />
                  </div>
                </>
              )
            ]
          },
          {
            language: 'pt',
            content: [
              <TextValidator
                style={{width: "100%", marginBottom: 15}}
                id="namePt"
                label={localization.get(selectedContentCreatorType.type ? 'form.title' : 'form.name')}
                name="namePt"
                value={namePt}
                onChange={onChange}
                disabled={disabled}
                validators={['required']}
                errorMessages={[localization.get('validator.is_required')]}
              />,

              <>
                {!isAudiovisual && !isTalent &&
                  <>
                    <TextValidator
                      style={{width: "100%", marginBotton: 15}}
                      id="categoryPt"
                      label={localization.get('form.section')}
                      name="categoryPt"
                      value={categoryPt}
                      onChange={onChange}
                      disabled={disabled}
                    />
                    <TextValidator
                      style={{width: "100%", marginBotton: 15}}
                      id="authorPt"
                      label={localization.get('form.author')}
                      name="authorPt"
                      value={authorPt}
                      onChange={onChange}
                      disabled={disabled}
                    />
                    <TextValidator
                      style={{width: "100%", marginBotton: 15}}
                      id="synopsisPt"
                      label={localization.get('form.synopsis')}
                      helperText={localization.get("form.synopsis_helper")}
                      name="synopsisPt"
                      value={synopsisPt}
                      onChange={onChange}
                      disabled={disabled}
                    />,
                  </>
                }
              </>,
              ((selectedContentCreatorType.type === 'audiovisual' || selectedContentCreatorType.type === 'talent') &&
                <>
                  <TextValidator
                    style={{display: "none"}}
                    id="descriptionPt"
                    label={localization.get('form.title')}
                    name="descriptionPt"
                    value={descriptionPt}
                    onChange={onChange}
                    disabled={disabled}
                    multiline
                    isEditorState={true}
                  />
                  <div id="ignore">
                    <div style={{marginBottom: "-2rem"}}>{localization.get('form.description')}</div>
                    <EditorialEditor
                      toolbarOptions={['inline', 'blockType', 'list', 'link', 'remove', 'history']}
                      editorState={descriptionPt}
                      onChange={(e) => onContentChange(e, 'descriptionPt')}
                    />
                  </div>
                </>
              )
            ]
          }
        ]}
      />


      {!isAudiovisual && !isTalent &&
      <>
        <TranslatableInputs
          isEditorialContent
          children={[
            {
              language: 'es',
              content: [
                <TextValidator
                  style={{display: "none"}}
                  id="descriptionEs"
                  label={localization.get('form.note')}
                  name="descriptionEs"
                  value={descriptionEs}
                  onChange={onChange}
                  disabled={disabled}
                />,
                <div id="ignore">
                  <div style={{marginBottom: "-2rem"}}>{localization.get('form.note')}</div>
                  <EditorialEditor
                    editorState={descriptionEs}
                    onChange={(e) => {
                      onContentChange(e, 'descriptionEs')
                    }}
                  />
                </div>
              ]
            },
            {
              language: 'en',
              content: [
                <TextValidator
                  style={{display: "none"}}
                  id="descriptionEn"
                  label={localization.get('form.description')}
                  name="descriptionEn"
                  value={descriptionEn}
                  onChange={onChange}
                  disabled={disabled}
                  multiline
                  isEditorState={true}
                />,
                <div id="ignore">
                  <div style={{marginBottom: "-2rem"}}>{localization.get('form.description')}</div>
                  <EditorialEditor
                    editorState={descriptionEn}
                    onChange={(e) => {
                      onContentChange(e, 'descriptionEn')
                    }}
                  />
                </div>
              ]
            },
            {
              language: 'pt',
              content: [
                <TextValidator
                  style={{display: "none"}}
                  id="descriptionPt"
                  label={localization.get('form.description')}
                  name="descriptionPt"
                  value={descriptionPt}
                  onChange={onChange}
                  disabled={disabled}
                  multiline
                  isEditorState={true}
                />,
                <div id="ignore">
                  <div style={{marginBottom: "-2rem"}}>{localization.get('form.description')}</div>
                  <EditorialEditor
                    editorState={descriptionPt}
                    onChange={(e) => {
                      onContentChange(e, 'descriptionPt')
                    }}
                  />
                </div>
              ]
            }
          ]}
        />


        <div style={{marginBottom: 20}}>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  style={{color: "#4cc2d5"}}
                  checked={hasSuggestedCarousel}
                  onChange={() => onSuggestedCarouselChange(!hasSuggestedCarousel)}
                />
              }
              label={localization.get('form.has_suggested_carousel')}
            />
          </div>

          {hasSuggestedCarousel &&
          <>
            <FormControl>
              <RadioGroup
                name="suggestedCarouselRadio"
                value={suggestedCarouselRadio}
                onChange={e => onImageRadiosChange(e)}
                style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
              >
                <FormControlLabel value="list" control={<Radio color="default"/>}
                                  label={localization.get('form.select_list')}/>
                <FormControlLabel value="suggested" control={<Radio color="default"/>}
                                  label={localization.get('form.suggested_by_platform')}/>
              </RadioGroup>
            </FormControl>

            {suggestedCarouselRadio === 'list' &&
            <AsyncSelect
              styles={{
                menu: base => ({
                  ...base,
                  zIndex: 10
                })
              }}
              theme={theme => ({
                ...theme,
                borderRadius: 0
              })}
              placeholder={localization.get('conversation.filter_users')}
              loadingMessage={() => localization.get('loading')}
              noOptionsMessage={() => localization.get('no_options')}
              onChange={onSuggestedCarouselPlaylistChange}
              value={suggestedCarouselPlaylist}
              loadOptions={inputValue => {
                let catalogsIds = selectedCatalogs.map(catalog => catalog.value)

                let filterBy = [{column: "title", filter: inputValue},
                  {column: 'channel_lists', filter: true},
                  {column: 'for_creators', filter: true},
                  {column: 'catalogs_ids', filter: catalogsIds}];

                return request.playlist.getAll({orderBy: {column: "title", type: "ASC"}, filterBy})
                  .then(lists => lists.map(list => ({value: list.id, label: list.title})))
              }}
              defaultOptions
            />
            }


          </>
          }
        </div>
      </>
      }


      {isTalent &&
      <>
        <TextValidator
          style={{width: "100%", marginBottom: "20px"}}
          id="email"
          label={localization.get('form.email')}
          name="email"
          value={email}
          onChange={onChange}
          disabled={disabled}
        />
        <TextValidator
          style={{width: "100%", marginBottom: "20px"}}
          id="phone"
          label={localization.get('form.phone')}
          name="phone"
          value={phone}
          onChange={onChange}
          disabled={disabled}
        />
        <FormControl fullWidth style={{marginBottom: "10px"}}>
          <span>{localization.get('form.country')} *</span>
          <AsyncSelect
            styles={{
              menu: base => ({
                ...base,
                zIndex: 10
              }),
              control: (base, state) => ({
                ...base,
                // state.isFocused can display different borderColor if you need it
                borderColor: state.isFocused ?
                  '#ddd' : countryIsCompleted ?
                    '#ddd' : 'red',
                // overwrittes hover style
                '&:hover': {
                  borderColor: state.isFocused ?
                    '#ddd' : countryIsCompleted ?
                      '#ddd' : 'red'
                }
              })
            }}
            theme={theme => ({
              ...theme,
              borderRadius: 0,
            })}
            placeholder={localization.get('conversation.filter_users')}
            loadingMessage={() => localization.get('loading')}
            noOptionsMessage={() => localization.get('no_options')}
            onChange={onAsyncCountriesChange}
            value={country}
            name={"country"}
            defaultOptions
            loadOptions={inputValue =>
              request.country
                .getAll({filterBy: [{column: "name", filter: inputValue}]})
                .then(res => res.sort((a, b) => a.name.localeCompare(b.name)).map(country => ({
                  value: country.id,
                  label: `${country.name}`
                })))
            }
            errorMessages={[localization.get("validator.is_required")]}
          />
        </FormControl>
        <FormControl fullWidth style={{marginBottom: "10px"}}>
          <span>{localization.get('form.residence')}</span>
          <AsyncSelect
            styles={{
              menu: base => ({
                ...base,
                zIndex: 10
              }),
              control: (base, state) => ({
                ...base,
                // state.isFocused can display different borderColor if you need it
                borderColor: '#ddd',
                // overwrittes hover style
                '&:hover': {
                  borderColor: '#ddd'
                }
              })
            }}
            theme={theme => ({
              ...theme,
              borderRadius: 0,
            })}
            placeholder={localization.get('conversation.filter_users')}
            loadingMessage={() => localization.get('loading')}
            noOptionsMessage={() => localization.get('no_options')}
            onChange={onResidenceChange}
            value={residence}
            name={"residence"}
            defaultOptions
            loadOptions={inputValue =>
              request.country
                .getAll({filterBy: [{column: "name", filter: inputValue}]})
                .then(res => res.sort((a, b) => a.name.localeCompare(b.name)).map(country => ({
                  value: country.id,
                  label: `${country.name}`
                })))
            }
          />
        </FormControl>
      </>
      }

      {!isAudiovisual &&
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          style={{marginBottom: 15}}
          fullWidth
          autoOk
          keyboard
          clearable
          onlyCalendar
          disableFuture
          defaultValue={startActivity}
          format={"dd/MM/yyyy"}
          label={localization.get(isTalent ? 'start_activity' : 'form.publish_date')}
          value={startActivity}
          onChange={handleStartActivityChange}
        />
      </MuiPickersUtilsProvider>
      }

      <React.Fragment>
        <br/>
        <br/>
        <TextValidator
          style={{width: "100%"}}
          id="weight"
          label={localization.get("form.weight")}
          helperText={localization.get("form.weight_helper")}
          InputProps={{inputProps: {min: 0, max: 999}}}
          type={"number"}
          onChange={onChange}
          name="weight"
          value={weight}
          onInput={(e) => {
            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
          }}
        />
      </React.Fragment>

      <SocialLinks socialLinks={socialLinks} onSocialLinksChange={onSocialLinksChange} max={3}/>
      <br/>
      <br/>
      <TextField
        id="profileUrl"
        type="text"
        onChange={onChange}
        fullWidth
        value={profileUrl}
        label={localization.get("talent_profile.edit_url_modal.title")}
        helperText={profileUrl ? localization.get("talent_profile.edit_url_modal.url_helper")+ `${window.location.protocol}//${window.location.hostname}/bl/${profileUrl}` : ""}
      />

      <br />
      <br />

      <h4>{localization.get('form.select_image_profile')}</h4>
      <FormControl>
        <RadioGroup
          name="profileImageRadio"
          value={profileImageRadio}
          onChange={e => onImageRadiosChange(e)}
          style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
        >
          <FormControlLabel value="filepond" control={<Radio color="default"/>}
                            label={localization.get('client_file.upload_from_computer')}/>
          <FormControlLabel value="unsplash" control={<Radio color="default"/>}
                            label={localization.get('form.upload_from_unsplash')}/>
        </RadioGroup>
      </FormControl>
      <br/>
      {profileImageRadio === 'filepond' ?
        <>
          {image && <ImagePicker image={image.src} previewOnly={true}/>}
          {image && image.id &&
          <div style={{textAlign: 'center'}}>
            <IconButton
              title={localization.get('download')}
              onClick={() => {
                request.file.image.getDownloadLink(image.id)
                  .then(link => window.open(link, '_blank'))
              }}
            >
              <CloudDownload/>
            </IconButton>
          </div>
          }
          <FilePondUploader
            disableForm={disableForm}
            updateDisableForm={updateDisableForm}
            file={image}
            id={"image"}
            type={"image"}
            allowedTypes={["image/*"]}
            onIdChange={onImageChange}
            setPreview={onSetPreview}
          />
          <div style={{
            color: "#757575",
            textAlign: 'center',
            marginTop: 5
          }}>{localization.get('helper_text.images_width_2048')}</div>
        </>
        : profileImageRadio === 'unsplash' ?
          <Unsplash imageAmount={9} onSelectImage={onSetProfileImageFromUnsplash}/>
          : null
      }

      <br/>
      <h4>{localization.get('form.select_image_cover')}</h4>
      <FormControl>
        <RadioGroup
          name="coverImageRadio"
          value={coverImageRadio}
          onChange={e => onImageRadiosChange(e)}
          style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
        >
          <FormControlLabel value="filepond" control={<Radio color="default"/>}
                            label={localization.get('client_file.upload_from_computer')}/>
          <FormControlLabel value="unsplash" control={<Radio color="default"/>}
                            label={localization.get('form.upload_from_unsplash')}/>
        </RadioGroup>
      </FormControl>
      {coverImageRadio === 'filepond' ?
        <>
          {coverImage && <ImagePicker image={coverImage.src} previewOnly={true}/>}
          <FilePondUploader
            disableForm={disableForm}
            updateDisableForm={updateDisableForm}
            file={coverImage}
            id={"cover"}
            type={"image"}
            allowedTypes={["image/*"]}
            onIdChange={onCoverImageChange}
            setPreview={onSetPreview}
          />
          <div style={{
            color: "#757575",
            textAlign: 'center',
            marginTop: 5
          }}>{localization.get('helper_text.images_width_2048')}</div>
        </>
        : coverImageRadio === 'unsplash' ?
          <Unsplash imageAmount={9} onSelectImage={onSetCoverImageFromUnsplash}/>
          : null
      }
      <br/>

      {tagGroups && tagGroups.length > 0 &&
      <FormTagSelection tagGroups={tagGroups} onSelectedTagsChanged={onSelectedTagsChanged} disabled={disabled}/>
      }


      <h4>{localization.get('form.download_material')}</h4>
      <TextValidator
        style={{width: "100%", margin: "-5px 0 15px"}}
        label={localization.get('form.title')}
        name="downloadableMaterialText"
        id="downloadableMaterialText"
        value={downloadableMaterialText}
        onChange={onChange}
      />
      <br/>
      <div>{localization.get('form.download_material_radio')}</div>


      <FormControl>
        <RadioGroup
          name="downloadableMaterialRadio"
          value={downloadableMaterialRadio}
          onChange={e => onImageRadiosChange(e)}
          style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
        >
          <FormControlLabel value="filepond" control={<Radio color="default"/>}
                            label={localization.get('client_file.upload_from_computer')}/>
          {selectedContentCreatorType.type === 'audiovisual' &&
          <FormControlLabel value="link" control={<Radio color="default"/>} label={localization.get('creation.link')}/>}
        </RadioGroup>
      </FormControl>


      {downloadableMaterialFilename &&
      <div>
        <span>{downloadableMaterialFilename}</span>
        <IconButton onClick={onDownloadableMaterialDelete} style={{marginBottom: 5}}>
          <Close/>
        </IconButton>
      </div>
      }
      {downloadableMaterialRadio === 'filepond' ?
        <FilePondUploader
          disableForm={disableForm}
          updateDisableForm={updateDisableForm}
          id={"downloadableMaterial"}
          allowedTypes={["video/mp4", "video/x-m4v", "video/*", ".mov", "image/*", "audio/*", "application/pdf", "application/zip", "application/rar"]}
          onIdChange={onDownloadableMaterialChange}
          setFileType={setDownloadableMaterialFileType}
        />
        :
        <TextValidator
          style={{width: "100%", marginBottom: "20px"}}
          id="downloadableMaterialLink"
          label={localization.get('form.link')}
          name="downloadableMaterialLink"
          value={downloadableMaterialLink}
          onChange={onChange}
          disabled={disabled}
        />
      }

      <h4>{localization.get('form.visibility')}</h4>
      <div style={{marginTop: 10}}>
        <FormControl>
          <RadioGroup
            name="active"
            id="active"
            value={active}
            onChange={e => onActiveChange(e.target.value)}
            style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
          >
            <FormControlLabel value="1" control={<Radio color="default"/>} label={localization.get('form.visible')}/>
            <FormControlLabel value="0" control={<Radio color="default"/>}
                              label={localization.get('form.not_visible')}/>
          </RadioGroup>
        </FormControl>
      </div>

      {/*{active === "1" && !isTalent &&
        <>
          <div>{localization.get('form.region')}</div>
          <FormControl>
            <RadioGroup
              name="onlyArgentina"
              value={onlyArgentina}
              onChange={e => onImageRadiosChange(e)}
              style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
            >
              <FormControlLabel value="false" control={<Radio color="default"/>} label={localization.get('form.all_world')}/>
              <FormControlLabel value="true" control={<Radio color="default"/>} label={localization.get('form.only_argentina')}/>
            </RadioGroup>
          </FormControl>

          <div>{localization.get('form.content_duration')}</div>
          <FormControl>
            <RadioGroup
              name="isPermanentContent"
              value={isPermanentContent}
              onChange={e => onIsPermanentContentChange(e.target.value)}
              style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
            >
              <FormControlLabel value="1" control={<Radio color="default"/>} label={localization.get('form.permanent_content')}/>
              <FormControlLabel value="0" control={<Radio color="default"/>} label={localization.get('form.not_permanent_content')}/>
            </RadioGroup>
          </FormControl>
          {isPermanentContent === "0" &&
          <div style={{width: "50%", display: "flex", flexDirection: "column", marginTop: 10}}>
            <div>{localization.get('form.range_disponibility')}</div>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DateTimePicker
                style={{marginBottom: 15}}
                autoOk
                autoSubmit
                disablePast
                ampm={false}
                format={"dd/MM/yyyy HH:mm a"}
                dateRangeIcon={<Event/>}
                id={"releaseDate"}
                defaultValue={releaseDate}
                helperText={localization.get("form.helper_datepicker_content_active")}
                label={localization.get('form.release_date')}
                value={releaseDate}
                onChange={e => {
                  onChange({
                    target: {
                      id: "releaseDate",
                      value: e,
                    }
                  })
                }}
              />
              <ErrorMessage name="startTime" className="web-like-error">
                {msg => <div className="web-like-error font12">{msg}</div>}
              </ErrorMessage>
            </MuiPickersUtilsProvider>
            <FormControlLabel
              control={
                <Checkbox
                  style={{color: "#4cc2d5"}}
                  checked={!hasExpiredDate}
                  onChange={() => onHasExpiredDateChange(!hasExpiredDate)}
                />
              }
              label={localization.get('has_expired_date')}
            />
            {hasExpiredDate &&
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DateTimePicker
                autoOk
                keyboard
                clearable
                onlyCalendar
                id={"expireDate"}
                disablePast
                defaultValue={expireDate}
                format={"dd/MM/yyyy HH:mm a"}
                disabled={!hasExpiredDate}
                helperText={localization.get("form.helper_datepicker_content_disactive")}
                label={localization.get('form.expire_date')}
                value={expireDate}
                onChange={e => {
                  onChange({
                    target: {
                      id: "expireDate",
                      value: e,
                    }
                  })
                }}
              />
            </MuiPickersUtilsProvider>
            }
          </div>
          }
        </>
        }
      <h4>{localization.get('form.require_login')}</h4>
      <div style={{marginTop: 10, position:"relative", float: "left", width: "100%"}}>
        <div style={{top: -38, left: 130, position: "absolute", cursor: "pointer"}} onClick={updateHelper}>
          <Help style={{fontSize: 15, color: "rgba(4, 175, 196, 1) "}}/>
        </div>
        <FormControl>
          <RadioGroup
            name="requireLogin"
            id="requireLogin"
            value={requireLogin}
            onChange={e => onRequireLoginChange(e.target.value)}
            style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
          >
            <FormControlLabel value="0" control={<Radio color="default"/>} label={localization.get('form.disabled')}/>
            <FormControlLabel value="1" control={<Radio color="default"/>} label={localization.get('form.active')}/>
          </RadioGroup>
        </FormControl>
      </div>
      */}
      <TextValidator
        style={{width: "100%", marginBottom: "20px"}}
        id="metadata"
        label={localization.get('form.hashtags')}
        name="metadata"
        value={metadata}
        onChange={onChange}
        disabled={disabled}
      />

      {contentCreations && selectedContentCreatorType && selectedContentCreatorType.type !== 'editorial' &&
      <React.Fragment>
        <div style={{width: "100%"}}>
          <h3 style={{
            float: "left",
            position: "relative",
            width: "auto"
          }}>{localization.get('content_creations.materials')}</h3>
          <Tooltip
            title={localization.get('view.content_creation.create')}
            placement='top'>
            <Button
              onClick={() => browserHistory.push(isTalent ? `/panel/talents/content_creations/create?contentCreator=${id}` : `/panel/audiovisual/content_creations/create?contentCreator=${id}`)}
              style={{height: 40, width: 40, backgroundColor: "#224b77", top: 15, left: 20}}
              variant="fab" color="primary" aria-label="Add"
            >
              <Add/>
            </Button>
          </Tooltip>
        </div>

        <ClientSidePaginationTable
          style={{width: "100%"}}
          showPagination={false}
          perPage={999}
          columns={[
            {
              id: 'order',
              Cell: ({original}) => {
                const ReorderButton = makeReorderButtonComponent(
                  contentCreations,
                  original,
                  reorderedSelected => onContentCreationsOrderChanged(reorderedSelected)
                );
                return (
                  <div style={{display: 'grid'}}>
                    <ReorderButton Icon={ArrowDropUp} nextIndex={index => index - 1} tooltipKey='move_up'/>
                    <ReorderButton Icon={ArrowDropDown} nextIndex={index => index + 1} tooltipKey='move_down'/>
                  </div>
                )
              },
              sortable: false,
              filterable: false,
              width: 50,
            },
            {
              id: "image",
              accessor: contentCreation => (
                <img alt="Content creation" src={makeImageUrlWithSize(contentCreation, 'xs')} width={50} height={50}/>
              ),
              style: {
                float: "left"
              },
              resizeable: false,
              sortable: false,
              filterable: false,
              width: 60
            },
            {
              Header: () =>
                <div
                  style={{
                    textAlign: "left"
                  }}
                >{localization.get('table.title')}</div>,
              accessor: "title",
              style: {
                float: "left"
              },
              filterable: false,
              sortable: false
            },
            {
              Header: localization.get('table.created_at'),
              id: 'created_at',
              accessor: contentCreation => localization.moment(contentCreation.created_at).fromNow(),
              style: {
                float: 'left',
              },
              resizeable: false,
              sortable: false,
              filterable: false,
            },
            {
              Header: localization.get('table.active'),
              id: 'active',
              accessor: contentCreation => (contentCreation.active ? <Done/> : <Close/>),
              style: {
                float: 'left',
              },
              resizeable: false,
              sortable: false,
              filterable: false,
            },
            {
              Header: localization.get('content_creation.material_type'),
              id: 'details',
              accessor: contentCreation => getContentCreationType(contentCreation),
              style: {
                textAlign: 'center',
              },
              resizeable: false,
              sortable: false,
              filterable: false,
            },
            {
              id: 'actions',
              Header: localization.get('table.actions'),
              sortable: false,
              filterable: false,
              accessor: (contentCreation) => buttons(contentCreation, handleContentCreationRemoved, isTalent),
              width: 145,
            }
          ]}
          data={contentCreations}
        />

      </React.Fragment>
      }
    </div>

  )};

const buttons = (contentCreation, handleContentCreationRemoved, isTalent) => {
  const {
    id,
    title,
    content_creator_id
  } = contentCreation;

  const buttonBuilder = new TableButtonsBuilder();

  buttonBuilder.withOther(
    <TableButton
      title={localization.get("download")}
      onClick={() => window.open(getCreationUrl(contentCreation), '_blank')}
    >
      <CloudDownload />
    </TableButton>
  );
  buttonBuilder.withEdit(isTalent ? `/panel/talents/content_creations/${id}/edit` : `/panel/audiovisual/content_creations/${id}/edit`);
  buttonBuilder.withDelete(title, () => request.contentCreation.delete(id), () => handleContentCreationRemoved(id));

  return buttonBuilder.build()
};


const getCreationUrl = (contentCreation) => {
  let url = "";
  if (contentCreation.video) {
    url = contentCreation.video.url;
  } else if (contentCreation.audio) {
    url = contentCreation.audio.url;
  } else if (contentCreation.binary) {
    url = contentCreation.binary.url;
  } else if (contentCreation.image) {
    url = contentCreation.image.url;
  }
  return url
}

const makeReorderButtonComponent = (selected, original, onReorder) => ({ tooltipKey, Icon, nextIndex }) => (
    <Tooltip title={localization.get(tooltipKey)}>
      <Icon style={{ cursor: 'pointer' }} onClick={() => {
        const index = selected.indexOf(original);
        const reorderedSelected = arrayMove(selected, index, nextIndex(index));
        onReorder(reorderedSelected)
      }} />
    </Tooltip>
  );

const getContentCreationType = contentCreation => {
  if(contentCreation.video) {
    if(contentCreation.video.job_status == "complete") {
      return localization.get(contentCreation.require_drm ? 'content_creation.video_drm' : 'content_creation.video_transcode')
    }
      return localization.get('content_creation.video_original')
  }else if (contentCreation.link) {
    return localization.get('content_creation.link')
  }else if (contentCreation.audio) {
    return localization.get('content_creation.audio')
  }else if (contentCreation.binary) {
    return localization.get('content_creation.binary')
  }else if (contentCreation.embededContent) {
    return localization.get('content_creation.embeded_content')
  }else {
    return localization.get('content_creation.image')
  }
}


export default FormContent